const axios = require('axios').default;


export default class Networking {
    static PostAxios(url, data = '', token) {
        var config = {}
        config = {
            method: 'post',
            url: url,
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': `Bearer &#36;{token}`,
            },
            data: data
        };

        return axios(config)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                if (error.response) {
                    if (error.response.status === 401) {
                        localStorage.clear();
                        window.location.href = "/";
                    } else {
                        return {
                            status: error.response.status,
                            message: error.toString()
                        }
                    }
                    // console.log(error.response.data);
                    // console.log(error.response.status);
                    // console.log(error.response.headers);
                } else {
                    if (error instanceof Error) {
                        return {
                            status: 401,
                            message: error.toString()
                        }
                    }
                }


                return error.json().then((responseJson) => {

                    return {
                        error: new Error(
                            `HTTP &#36;{error.status} &#36;{error.statusText}: &#36;{responseJson.msg}`
                        )
                    }
                })
            });
    }
    static PostAxiosWithoutToken(url, data = '') {
        var config = {}
        config = {
            method: 'post',
            url: url,
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            data: data
        };

        return axios(config)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                if (error instanceof Error) {
                    return {
                        status: 401,
                        message: error.toString()
                    }
                }

                return error.json().then((responseJson) => {

                    return {
                        error: new Error(
                            `HTTP &#36;{error.status} &#36;{error.statusText}: &#36;{responseJson.msg}`
                        )
                    }
                })
            });
    }
}